module.exports = __webpack_public_path__ + "static/img/img-banner2.f53a4466.gif";